'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoaded = isLoaded;
exports.load = load;
exports.loadRandomInspirations = loadRandomInspirations;

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'redux-frontend/inspirations/LOAD';
var LOAD_SUCCESS = 'redux-frontend/inspirations/LOAD_SUCCESS';
var LOAD_FAIL = 'redux-frontend/inspirations/LOAD_FAIL';

var LOAD_RANDOM = 'redux-frontend/inspirations/LOAD_RANDOM';
var LOAD_RANDOM_SUCCESS = 'redux-frontend/inspirations/LOAD_RANDOM_SUCCESS';
var LOAD_RANDOM_FAIL = 'redux-frontend/inspirations/LOAD_RANDOM_FAIL';

var initialState = {
  loaded: false,
  data: [],
  randomInspirations: []
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        data: action.result,
        error: null
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        data: null,
        error: action.error
      });
    case LOAD_RANDOM_SUCCESS:
      return (0, _extends3.default)({}, state, {
        randomInspirations: (0, _lodash.shuffle)(action.result).slice(0, 3)
      });
    default:
      return state;
  }
}

function isLoaded(globalState) {
  return globalState.inspirations && globalState.inspirations.loaded;
}

function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('/inspirations');
    }
  };
}

function loadRandomInspirations() {
  return {
    types: [LOAD_RANDOM, LOAD_RANDOM_SUCCESS, LOAD_RANDOM_FAIL],
    promise: function promise(client) {
      return client.get('/inspirations');
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/inspirations.js
// module id = 265
// module chunks = 47